export default __webpack_public_path__ + "e08c15f16efebd23d007a9262cb5892d.ttf";